export default "__VITE_ASSET__bBLMnVCb__"